import { CropCycle, CropCycleV2 } from "@/types/cropCycle";
import dayjs from "dayjs";

export function getCropCycleDisplay(cropCycle: CropCycle) {
    const cropName = cropCycle.crop
        ? cropCycle.crop
        : !cropCycle.end_date
          ? "Current"
          : " Corn";
    const yearStart = dayjs(cropCycle.start_date).year();
    const yearEnd = (
        cropCycle.end_date ? dayjs(cropCycle.end_date) : dayjs()
    ).year();
    if (yearStart == yearEnd) {
        return `${cropName} ${yearStart}`;
    } else {
        return `${cropName} ${yearStart}-${yearEnd}`;
    }
}

export function getCropCycleV2Display(cropCycle: CropCycleV2) {
    const display = `${cropCycle.effective_planting_operation.crop_configuration.crop_name} ${dayjs(cropCycle.effective_planting_operation.start_date).year()}`;
    if (!cropCycle.planting_operation || cropCycle.planting_operation === -1) {
        return `${display} (No Planting Operation)`;
    }
    return display;
}
